export interface PaginationModel {
  totalItems?: number;
  currentPage: number;
  itemsPerPage: number;
}
